module.exports = __webpack_public_path__ + "img/Roboto-Regular.e67b622.svg";